import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import * as actions from '@/components/Toast/toastSlice';

type ToastOptions = Omit<Toast, 'type' | 'description'>;

/**
 * 토스트를 호출하는 hook
 * @example
 * import useToast from '@/hooks/useToast';
 *
 * const Component = () => {
 *   	const toast = useToast();
 *
 *    return (
 *       <button
 *          onClick={()=> {
 *             toast.success('your message', {time: 300, closeOnClick: true});}
 *             toast.error('your message');
 *          }
 *       />
 *    )
 * }
 *
 */

export default function useToast() {
  const dispatch = useDispatch();

  const toast = useMemo(
    () => ({
      success(message: string, props?: ToastOptions) {
        dispatch(
          actions.setToast({ type: 'success', description: message, ...props })
        );
      },
      error(message: string, props?: ToastOptions) {
        dispatch(
          actions.setToast({ type: 'error', description: message, ...props })
        );
      },
      warning(message: string, props?: ToastOptions) {
        dispatch(
          actions.setToast({ type: 'warning', description: message, ...props })
        );
      },
      info(message: string, props?: ToastOptions) {
        dispatch(
          actions.setToast({ type: 'info', description: message, ...props })
        );
      },
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return toast;
}
